// @flow
import * as React from 'react';
import AmpContext from 'utils/AmpContext';

type Props = { children: React.Node };

export default class NoAmp extends React.PureComponent<Props> {
  static contextType = AmpContext;

  render() {
    return (
      <AmpContext.Consumer>
        {requestIsAmp => {
          if (requestIsAmp) {
            return null;
          }
          return this.props.children;
        }}
      </AmpContext.Consumer>
    );
  }
}
